         document.addEventListener('DOMContentLoaded', function () {
     var openBtn = document.querySelector('[data-personalised-open]');
var modal = document.querySelector('[data-personalised-modal]');
var PRODUCT_FORM_ID = modal ? modal.getAttribute('data-product-form-id') : '';
var closeBtns = document.querySelectorAll('[data-personalised-close]'); 

      var stepUpload = document.getElementById('personalisedStepUpload');
      var stepCrop = document.getElementById('personalisedStepCrop');
      var stepCustomize = document.getElementById('personalisedStepCustomize');

      var headerTitle = document.getElementById('personalisedHeaderTitle');
      var backBtn = document.getElementById('personalisedBackBtn');
      var changeImageBtn = document.getElementById('personalisedChangeImageBtn');

      var imageUpload = document.getElementById('personalisedImageUpload');
      var uploadFilename = document.getElementById('personalisedUploadFilename');
      var uploadPlusBtn = document.querySelector('[data-personalised-upload-trigger]');

      var cropStage = document.getElementById('personalisedCropStage');
      var cropImage = document.getElementById('personalisedCropImage');
      var rotateBtn = document.getElementById('personalisedRotateBtn');
      var zoomRange = document.getElementById('personalisedZoomRange');
      var qualityBtn = document.getElementById('personalisedQualityBtn');
      var qualityFill = document.getElementById('personalisedQualityFill');
      var qualityText = document.getElementById('personalisedQualityText');

      var qualityGoodLabel = qualityBtn
        ? (qualityBtn.getAttribute('data-quality-good') || 'Sehr gut')
        : 'Sehr gut';
      var qualityMediumLabel = qualityBtn
        ? (qualityBtn.getAttribute('data-quality-medium') || 'Mittel')
        : 'Mittel';
      var qualityBadLabel = qualityBtn
        ? (qualityBtn.getAttribute('data-quality-bad') || 'Schlecht')
        : 'Schlecht';
      var cropConfirmBtn = document.getElementById('personalisedCropConfirmBtn');
      var newUploadBtn = document.getElementById('personalisedNewUploadBtn');

      var previewImage = document.getElementById('personalisedPreviewImage');

      var input1 = document.getElementById('personalisedInputLine1');
      var input2 = document.getElementById('personalisedInputLine2');
      var previewTextWrap = document.getElementById('personalisedPreviewText');
      var preview1 = document.getElementById('personalisedPreviewLine1');
      var preview2 = document.getElementById('personalisedPreviewLine2');

      var primaryActionBtn = document.getElementById('personalisedPrimaryActionBtn');
      var primaryActionLabel = primaryActionBtn
        ? primaryActionBtn.querySelector('[data-personalised-primary-label]')
        : null;

      var continueLabel = modal
        ? (modal.getAttribute('data-continue-label') || 'WEITER')
        : 'WEITER';
      var addToCartLabel = modal
        ? (modal.getAttribute('data-add-to-cart-label') || 'IN DEN WARENKORB')
        : 'IN DEN WARENKORB';
      var addToCartLoadingLabel = modal
        ? (modal.getAttribute('data-add-to-cart-loading-label') || 'WIRD HINZUGEFÜGT...')
        : 'WIRD HINZUGEFÜGT...';

      var editorFlow = modal
        ? String(modal.getAttribute('data-editor-flow') || 'text,border,size')
            .split(',')
            .map(function(item) { return item.trim(); })
            .filter(Boolean)
        : ['text', 'border', 'size'];

      var currentEditorTab = editorFlow[0] || 'text';

// Der Personalisierungs-Editor sitzt im Modal, die Produktvarianten dagegen
// auf der Produktseite. Deshalb werden nur die Editor-Elemente im Modal gesucht.
var personalisedRoot = modal || document;

var frame = personalisedRoot.querySelector('.ps-poster-frame');
var previewOuter = personalisedRoot.querySelector('.ps-preview-outer');
var productFrameOverlay = document.getElementById('personalisedProductFrameOverlay');
var frameButtons = document.querySelectorAll('[data-frame-option]');
var fontButtons = document.querySelectorAll('[data-font-option]');

var editorTabs = document.querySelectorAll('[data-editor-tab]');
var editorPanels = document.querySelectorAll('[data-editor-panel]');
var editorCropWrap = document.getElementById('personalisedEditorCropWrap');
var editorPreviewWrap = document.getElementById('personalisedEditorPreviewWrap');
var editorFooter = personalisedRoot.querySelector('.ps-editor-footer');
var sizeButtons = personalisedRoot.querySelectorAll('[data-size-option]');
var productFrameButtons = personalisedRoot.querySelectorAll('[data-product-frame-option]');

// Diese Elemente liegen AUSSERHALB von [data-personalised-modal].
var customFrameCards = document.querySelectorAll('.product-detail__variant-picker [data-custom-frame-value]');
var customFrameCardPrices = document.querySelectorAll('.product-detail__variant-picker [data-frame-card-price]');
var customSizePicker = document.querySelector('.product-detail__variant-picker [data-custom-size-picker]');
var customSizeTrigger = document.querySelector('.product-detail__variant-picker [data-custom-size-trigger]');
var customSizeTriggerText = document.querySelector('.product-detail__variant-picker [data-custom-size-trigger-text]');
var customSizeDropdown = document.querySelector('.product-detail__variant-picker [data-custom-size-dropdown]');
var customSizeSheet = document.querySelector('.product-detail__variant-picker [data-custom-size-sheet]') ||
                      document.querySelector('[data-custom-size-sheet]');
var customSizeCloseButtons = document.querySelectorAll('[data-custom-size-close]');
// Das Classic-Picker-Skript hängt den mobilen Bottom-Sheet an <body>.
// Deshalb BEIDE Optionslisten explizit auslesen, auch wenn das Sheet
// außerhalb der Produktinformationen liegt. Sonst reagieren mobile Größen nicht.
var customSizeOptions = Array.from(new Set([
  ...(customSizePicker ? customSizePicker.querySelectorAll('[data-custom-size-value]') : []),
  ...(customSizeSheet ? customSizeSheet.querySelectorAll('[data-custom-size-value]') : [])
]));

      var selectedSizeUpload = document.getElementById('personalisedSelectedSizeUpload');
      var selectedFrameUpload = document.getElementById('personalisedSelectedFrameUpload');
      var exportSizeUpload = document.getElementById('personalisedExportSizeUpload');

      var selectedSizeCrop = document.getElementById('personalisedSelectedSizeCrop');
      var selectedFrameCrop = document.getElementById('personalisedSelectedFrameCrop');
      var exportSizeCrop = document.getElementById('personalisedExportSizeCrop');

      var selectedSizeCustomize = document.getElementById('personalisedSelectedSizeCustomize');
      var selectedFrameCustomize = document.getElementById('personalisedSelectedFrameCustomize');
      var exportSizeCustomize = document.getElementById('personalisedExportSizeCustomize');

      var currentStep = 'upload';
      var cropDirty = false;
      var SIZE_CONFIG = {
        '21x30 cm': {
          ratioCss: '21 / 30',
          exportWidth: 2480,
          exportHeight: 3543,
          previewWidth: 400
        },
        '30x40 cm': {
          ratioCss: '30 / 40',
          exportWidth: 3543,
          exportHeight: 4724,
          previewWidth: 400
        },
        '50x70 cm': {
          ratioCss: '50 / 70',
          exportWidth: 5906,
          exportHeight: 8268,
          previewWidth: 400
        },
        '70x100 cm': {
          ratioCss: '70 / 100',
          exportWidth: 8268,
          exportHeight: 11811,
          previewWidth: 400
        }
      };

      const frameMap = {
        // ========== DEUTSCH ==========
        "21x30 cm|Weiter ohne Rahmen": null,
        "30x40 cm|Weiter ohne Rahmen": null,
        "50x70 cm|Weiter ohne Rahmen": null,
        "70x100 cm|Weiter ohne Rahmen": null,
        "21x30 cm|Bilderrahmen Holz Schwarz": 55645369368963,
        "30x40 cm|Bilderrahmen Holz Schwarz": 55645369401731,
        "50x70 cm|Bilderrahmen Holz Schwarz": 55645369434499,
        "50x50 cm|Bilderrahmen Holz Schwarz": 56251856224643,
        "70x100 cm|Bilderrahmen Holz Schwarz": 55851133043075,
        "21x30 cm|Bilderrahmen Holz Weiß": 55646396580227,
        "30x40 cm|Bilderrahmen Holz Weiß": 55646396612995,
        "50x70 cm|Bilderrahmen Holz Weiß": 55646396645763,
        "50x50 cm|Bilderrahmen Holz Weiß": 56251856781699,
        "70x100 cm|Bilderrahmen Holz Weiß": 55851149099395,
        "21x30 cm|Bilderrahmen Holz Eiche": 48058528727357,
        "30x40 cm|Bilderrahmen Holz Eiche": 48058528792893,
        "50x70 cm|Bilderrahmen Holz Eiche": 48058528858429,
        "50x50 cm|Bilderrahmen Holz Eiche": 56251847016835,
        "70x100 cm|Bilderrahmen Holz Eiche": 55851124588931,

        // ========== DÄNISCH ==========
        "21x30 cm|Fortsæt uden ramme": null,
        "30x40 cm|Fortsæt uden ramme": null,
        "50x70 cm|Fortsæt uden ramme": null,
        "70x100 cm|Fortsæt uden ramme": null,
        "21x30 cm|Billedramme Træ Premium Sort": 55645369368963,
        "30x40 cm|Billedramme Træ Premium Sort": 55645369401731,
        "50x70 cm|Billedramme Træ Premium Sort": 55645369434499,
        "50x50 cm|Billedramme Træ Premium Sort": 56251856224643,
        "70x100 cm|Billedramme Træ Premium Sort": 55851133043075,
        "21x30 cm|Billedramme Træ Premium Hvid": 55646396580227,
        "30x40 cm|Billedramme Træ Premium Hvid": 55646396612995,
        "50x70 cm|Billedramme Træ Premium Hvid": 55646396645763,
        "50x50 cm|Billedramme Træ Premium Hvid": 56251856781699,
        "70x100 cm|Billedramme Træ Premium Hvid": 55851149099395,
        "21x30 cm|Billedramme Træ Premium Eg": 48058528727357,
        "30x40 cm|Billedramme Træ Premium Eg": 48058528792893,
        "50x70 cm|Billedramme Træ Premium Eg": 48058528858429,
        "50x50 cm|Billedramme Træ Premium Eg": 56251847016835,
        "70x100 cm|Billedramme Træ Premium Eg": 55851124588931,

        // ========== ENGLISCH ==========
        "21x30 cm (8\" x 12\" in)|Continue without frame": null,
        "30x40 cm (12\" x 16\" in)|Continue without frame": null,
        "50x70 cm (20\" x 28\" in)|Continue without frame": null,
        "70x100 cm (28\" x 39\" in)|Continue without frame": null,
        "21x30 cm (8\" x 12\" in)|Picture Frame Premium Wood Black": 55645369368963,
        "30x40 cm (12\" x 16\" in)|Picture Frame Premium Wood Black": 55645369401731,
        "50x70 cm (20\" x 28\" in)|Picture Frame Premium Wood Black": 55645369434499,
        "50x50 cm (20\" x 20\" in)|Picture Frame Premium Wood Black": 56251856224643,
        "70x100 cm (28\" x 39\" in)|Picture Frame Premium Wood Black": 55851133043075,
        "21x30 cm (8\" x 12\" in)|Picture Frame Premium Wood White": 55646396580227,
        "30x40 cm (12\" x 16\" in)|Picture Frame Premium Wood White": 55646396612995,
        "50x70 cm (20\" x 28\" in)|Picture Frame Premium Wood White": 55646396645763,
        "50x50 cm (20\" x 20\" in)|Picture Frame Premium Wood White": 56251856781699,
        "70x100 cm (28\" x 39\" in)|Picture Frame Premium Wood White": 55851149099395,
        "21x30 cm (8\" x 12\" in)|Picture Frame Premium Oak": 48058528727357,
        "30x40 cm (12\" x 16\" in)|Picture Frame Premium Oak": 48058528792893,
        "50x70 cm (20\" x 28\" in)|Picture Frame Premium Oak": 48058528858429,
        "50x50 cm (20\" x 20\" in)|Picture Frame Premium Oak": 56251847016835,
        "70x100 cm (28\" x 39\" in)|Picture Frame Premium Oak": 55851124588931,

        // ========== SPANISCH ==========
        "21x30 cm|Continuar sin marco": null,
        "30x40 cm|Continuar sin marco": null,
        "50x70 cm|Continuar sin marco": null,
        "70x100 cm|Continuar sin marco": null,
        "21x30 cm|Marco de Madera Premium Negro": 55645369368963,
        "30x40 cm|Marco de Madera Premium Negro": 55645369401731,
        "50x70 cm|Marco de Madera Premium Negro": 55645369434499,
        "50x50 cm|Marco de Madera Premium Negro": 56251856224643,
        "70x100 cm|Marco de Madera Premium Negro": 55851133043075,
        "21x30 cm|Marco de Madera Premium Blanco": 55646396580227,
        "30x40 cm|Marco de Madera Premium Blanco": 55646396612995,
        "50x70 cm|Marco de Madera Premium Blanco": 55646396645763,
        "50x50 cm|Marco de Madera Premium Blanco": 56251856781699,
        "70x100 cm|Marco de Madera Premium Blanco": 55851149099395,
        "21x30 cm|Marco de Madera Premium Roble": 48058528727357,
        "30x40 cm|Marco de Madera Premium Roble": 48058528792893,
        "50x70 cm|Marco de Madera Premium Roble": 48058528858429,
        "50x50 cm|Marco de Madera Premium Roble": 56251847016835,
        "70x100 cm|Marco de Madera Premium Roble": 55851124588931,

        // ========== FRANZÖSISCH ==========
        "21x30 cm|Continuer sans cadre": null,
        "30x40 cm|Continuer sans cadre": null,
        "50x70 cm|Continuer sans cadre": null,
        "70x100 cm|Continuer sans cadre": null,
        "21x30 cm|Cadre Photo Bois Premium Noir": 55645369368963,
        "30x40 cm|Cadre Photo Bois Premium Noir": 55645369401731,
        "50x70 cm|Cadre Photo Bois Premium Noir": 55645369434499,
        "50x50 cm|Cadre Photo Bois Premium Noir": 56251856224643,
        "70x100 cm|Cadre Photo Bois Premium Noir": 55851133043075,
        "21x30 cm|Cadre Photo Bois Premium Blanc": 55646396580227,
        "30x40 cm|Cadre Photo Bois Premium Blanc": 55646396612995,
        "50x70 cm|Cadre Photo Bois Premium Blanc": 55646396645763,
        "50x50 cm|Cadre Photo Bois Premium Blanc": 56251856781699,
        "70x100 cm|Cadre Photo Bois Premium Blanc": 55851149099395,
        "21x30 cm|Cadre Photo Bois Premium Chêne": 48058528727357,
        "30x40 cm|Cadre Photo Bois Premium Chêne": 48058528792893,
        "50x70 cm|Cadre Photo Bois Premium Chêne": 48058528858429,
        "50x50 cm|Cadre Photo Bois Premium Chêne": 56251847016835,
        "70x100 cm|Cadre Photo Bois Premium Chêne": 55851124588931,

        // ========== ITALIENISCH ==========
        "21x30 cm|Continua senza cornice": null,
        "30x40 cm|Continua senza cornice": null,
        "50x70 cm|Continua senza cornice": null,
        "70x100 cm|Continua senza cornice": null,
        "21x30 cm|Cornice Premium Legno Nero": 55645369368963,
        "30x40 cm|Cornice Premium Legno Nero": 55645369401731,
        "50x70 cm|Cornice Premium Legno Nero": 55645369434499,
        "50x50 cm|Cornice Premium Legno Nero": 56251856224643,
        "70x100 cm|Cornice Premium Legno Nero": 55851133043075,
        "21x30 cm|Cornice Premium Legno Bianco": 55646396580227,
        "30x40 cm|Cornice Premium Legno Bianco": 55646396612995,
        "50x70 cm|Cornice Premium Legno Bianco": 55646396645763,
        "50x50 cm|Cornice Premium Legno Bianco": 56251856781699,
        "70x100 cm|Cornice Premium Legno Bianco": 55851149099395,
        "21x30 cm|Cornice Premium Rovere": 48058528727357,
        "30x40 cm|Cornice Premium Rovere": 48058528792893,
        "50x70 cm|Cornice Premium Rovere": 48058528858429,
        "50x50 cm|Cornice Premium Rovere": 56251847016835,
        "70x100 cm|Cornice Premium Rovere": 55851124588931,

        // ========== NORWEGISCH ==========
        "21x30 cm|Fortsett uten Ramme": null,
        "30x40 cm|Fortsett uten Ramme": null,
        "50x70 cm|Fortsett uten Ramme": null,
        "70x100 cm|Fortsett uten Ramme": null,
        "21x30 cm|Bilderamme Tre Premium Svart": 55645369368963,
        "30x40 cm|Bilderamme Tre Premium Svart": 55645369401731,
        "50x70 cm|Bilderamme Tre Premium Svart": 55645369434499,
        "50x50 cm|Bilderamme Tre Premium Svart": 56251856224643,
        "70x100 cm|Bilderamme Tre Premium Svart": 55851133043075,
        "21x30 cm|Bilderamme Tre Premium Hvit": 55646396580227,
        "30x40 cm|Bilderamme Tre Premium Hvit": 55646396612995,
        "50x70 cm|Bilderamme Tre Premium Hvit": 55646396645763,
        "50x50 cm|Bilderamme Tre Premium Hvit": 56251856781699,
        "70x100 cm|Bilderamme Tre Premium Hvit": 55851149099395,
        "21x30 cm|Bilderamme Tre Premium Eik": 48058528727357,
        "30x40 cm|Bilderamme Tre Premium Eik": 48058528792893,
        "50x70 cm|Bilderamme Tre Premium Eik": 48058528858429,
        "50x50 cm|Bilderamme Tre Premium Eik": 56251847016835,
        "70x100 cm|Bilderamme Tre Premium Eik": 55851124588931,

        // ========== SCHWEDISCH ==========
        "21x30 cm|Fortsätt utan Ram": null,
        "30x40 cm|Fortsätt utan Ram": null,
        "50x70 cm|Fortsätt utan Ram": null,
        "70x100 cm|Fortsätt utan Ram": null,
        "21x30 cm|Tavelram Trä Premium Svart": 55645369368963,
        "30x40 cm|Tavelram Trä Premium Svart": 55645369401731,
        "50x70 cm|Tavelram Trä Premium Svart": 55645369434499,
        "50x50 cm|Tavelram Trä Premium Svart": 56251856224643,
        "70x100 cm|Tavelram Trä Premium Svart": 55851133043075,
        "21x30 cm|Tavelram Trä Premium Vit": 55646396580227,
        "30x40 cm|Tavelram Trä Premium Vit": 55646396612995,
        "50x70 cm|Tavelram Trä Premium Vit": 55646396645763,
        "50x50 cm|Tavelram Trä Premium Vit": 56251856781699,
        "70x100 cm|Tavelram Trä Premium Vit": 55851149099395,
        "21x30 cm|Tavelram Trä Premium Ek": 48058528727357,
        "30x40 cm|Tavelram Trä Premium Ek": 48058528792893,
        "50x70 cm|Tavelram Trä Premium Ek": 48058528858429,
        "50x50 cm|Tavelram Trä Premium Ek": 56251847016835,
        "70x100 cm|Tavelram Trä Premium Ek": 55851124588931,

        // ========== NIEDERLÄNDISCH ==========
        "21x30 cm|Doorgaan zonder frame": null,
        "30x40 cm|Doorgaan zonder frame": null,
        "50x70 cm|Doorgaan zonder frame": null,
        "70x100 cm|Doorgaan zonder frame": null,
        "21x30 cm|Fotolijst Hout Premium Zwart": 55645369368963,
        "30x40 cm|Fotolijst Hout Premium Zwart": 55645369401731,
        "50x70 cm|Fotolijst Hout Premium Zwart": 55645369434499,
        "50x50 cm|Fotolijst Hout Premium Zwart": 56251856224643,
        "70x100 cm|Fotolijst Hout Premium Zwart": 55851133043075,
        "21x30 cm|Fotolijst Hout Premium Wit": 55646396580227,
        "30x40 cm|Fotolijst Hout Premium Wit": 55646396612995,
        "50x70 cm|Fotolijst Hout Premium Wit": 55646396645763,
        "50x50 cm|Fotolijst Hout Premium Wit": 56251856781699,
        "70x100 cm|Fotolijst Hout Premium Wit": 55851149099395,
        "21x30 cm|Fotolijst Hout Premium Eiken": 48058528727357,
        "30x40 cm|Fotolijst Hout Premium Eiken": 48058528792893,
        "50x70 cm|Fotolijst Hout Premium Eiken": 48058528858429,
        "50x50 cm|Fotolijst Hout Premium Eiken": 56251847016835,
        "70x100 cm|Fotolijst Hout Premium Eiken": 55851124588931
      };

      var framePriceCache = {};

function getActiveCurrencyCode() {
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
    return window.Shopify.currency.active;
  }
  return 'EUR';
}

function formatMoneyByMarket(amount) {
  var currencyCode = getActiveCurrencyCode();
  var numericAmount = Number(amount || 0) / 100;

  try {
    if (currencyCode === 'EUR') {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numericAmount) + ' €';
    }

    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: currencyCode
    }).format(numericAmount);
  } catch (e) {
    if (currencyCode === 'EUR') {
      return numericAmount.toFixed(2).replace('.', ',') + ' €';
    }

    return numericAmount.toFixed(2) + ' ' + currencyCode;
  }
}

function getFramePriceLookupKey(sizeLabel, frameLabel) {
  return String(sizeLabel || '').trim() + '|' + String(frameLabel || '').trim();
}

async function fetchVariantPriceById(variantId) {
  if (!variantId) return 0;

  if (Object.prototype.hasOwnProperty.call(framePriceCache, variantId)) {
    return framePriceCache[variantId];
  }

  var response = await fetch('/variants/' + variantId + '.js');
  if (!response.ok) {
    throw new Error('Preis für Variante ' + variantId + ' konnte nicht geladen werden');
  }

  var data = await response.json();
  var result = {
    price: Number(data.price || 0),
    compare: Number(data.compare_at_price || 0)
  };

  framePriceCache[variantId] = result;
  return result;
}

async function updateCustomFrameCardPrices() {
  if (!customFrameCardPrices.length) return;

  var currentSizeLabel = selectedConfig.sizeLabel || '';
  if (!currentSizeLabel) return;

  for (var i = 0; i < customFrameCardPrices.length; i++) {
    var priceEl = customFrameCardPrices[i];
    var frameLabel = (priceEl.getAttribute('data-frame-card-value') || '').trim();

    if (!frameLabel) continue;

    var frameVariantId = getFrameVariantId(currentSizeLabel, frameLabel);

    if (!frameVariantId) {
      priceEl.textContent = '+' + formatMoneyByMarket(0);
      continue;
    }

    try {
      var framePrices = await fetchVariantPriceById(frameVariantId);
      priceEl.textContent = '+' + formatMoneyByMarket(framePrices.price);
      var compareEl = priceEl.parentElement.querySelector('.ds-classic-frame-compare');
      if (framePrices.compare > framePrices.price) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'ds-classic-frame-compare';
          priceEl.insertAdjacentElement('afterend', compareEl);
        }
        compareEl.textContent = '+' + formatMoneyByMarket(framePrices.compare);
        priceEl.classList.add('is-sale');
      } else {
        if (compareEl) compareEl.remove();
        priceEl.classList.remove('is-sale');
      }
    } catch (error) {
      console.warn('Rahmenpreis konnte nicht geladen werden:', frameLabel, error);
      priceEl.textContent = '+–';
    }
  }
}

function refreshCustomFramePricesDelayed(delay) {
  window.setTimeout(function() {
    var ok = syncSelectionFromShopify();
    if (!ok) return;

    syncSizeButtons();
    syncProductFrameButtons();
    syncCustomFrameCards();
    updateCustomFrameCardPrices();
  }, delay || 180);
}

        var selectedConfig = {
  posterVariantId: '',
  frameVariantId: null,
  sizeLabel: '',
  sizeKey: '',
  frameLabel: '',
  exportWidth: 0,
  exportHeight: 0,
  previewWidth: 280,
  ratioCss: '3 / 4',
  frameStyle: 'white',
  fontStyle: 'modern',
  productFrameStyle: 'none',
  previewDataUrl: '',
  uploadFile: null,
  previewBlob: null,
  printBlob: null,
  previewUrl: '',
  printKey: '',
  printUrl: '',
  designKey: '',
  designUrl: '',
  cropData: null,
  bundleToken: ''
};

        /*
         * SPEED:
         * Das große Originalbild wird bereits nach Bestätigung des Crops
         * im Hintergrund zu R2 hochgeladen. Dadurch läuft dieser Upload,
         * während der Kunde Text, Rand, Größe und Rahmen auswählt.
         *
         * Die finale Warenkorb-Aktion muss dann normalerweise nur noch
         * die kleine Preview hochladen.
         */
        var originalPreuploadState = {
          file: null,
          promise: null,
          signed: null,
          uploaded: false
        };

        function createPersonalisedBundleToken() {
          return 'ps-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        }

        function resetOriginalPreupload() {
          originalPreuploadState.file = null;
          originalPreuploadState.promise = null;
          originalPreuploadState.signed = null;
          originalPreuploadState.uploaded = false;
        }

        /*
         * SPEED – CART PREVIEW
         *
         * html2canvas kann auf Handys spürbar Zeit brauchen.
         * Deshalb bereiten wir die kleine Warenkorb-Preview bereits
         * im letzten Editor-Schritt im Hintergrund vor.
         */
        function isMobilePersonalisedDevice() {
          return !!(
            window.matchMedia &&
            window.matchMedia('(max-width: 768px)').matches
          );
        }

        var cartPreviewState = {
          version: 0,
          builtVersion: -1,
          promise: null,
          timer: null
        };

        function resetCartPreviewCache() {
          if (cartPreviewState.timer) {
            window.clearTimeout(cartPreviewState.timer);
          }

          cartPreviewState.version += 1;
          cartPreviewState.builtVersion = -1;
          cartPreviewState.promise = null;
          cartPreviewState.timer = null;
          selectedConfig.previewBlob = null;
        }

        function isFinalEditorStep() {
          var lastFlowStep = editorFlow.length
            ? editorFlow[editorFlow.length - 1]
            : 'size';

          return currentEditorTab === lastFlowStep;
        }

        function markCartPreviewDirty(shouldSchedule) {
          resetCartPreviewCache();

          if (shouldSchedule) {
            scheduleCartPreviewPrebuild();
          }
        }

        function scheduleCartPreviewPrebuild(delay) {
          if (!selectedConfig.previewDataUrl) return;
          if (!isFinalEditorStep()) return;

          /*
           * Auf Handy wird die Cart-Preview vollständig serverseitig
           * erzeugt. Dadurch läuft dort niemals html2canvas.
           */
          if (isMobilePersonalisedDevice()) {
            return;
          }

          if (cartPreviewState.timer) {
            window.clearTimeout(cartPreviewState.timer);
          }

          var effectiveDelay =
            typeof delay === 'number'
              ? delay
              : (
                  window.matchMedia &&
                  window.matchMedia('(max-width: 768px)').matches
                    ? 120
                    : 350
                );

          cartPreviewState.timer = window.setTimeout(function() {
            cartPreviewState.timer = null;

            /*
             * Wenn der Browser requestIdleCallback unterstützt, benutzen
             * wir eine ruhige Phase. Safari/iPhone fällt automatisch auf
             * setTimeout zurück.
             */
            if (typeof window.requestIdleCallback === 'function') {
              window.requestIdleCallback(function() {
                prebuildCartPreviewInBackground();
              }, { timeout: 1000 });
            } else {
              window.setTimeout(function() {
                prebuildCartPreviewInBackground();
              }, 0);
            }
          }, effectiveDelay);
        }

        async function prebuildCartPreviewInBackground() {
          if (!selectedConfig.previewDataUrl) return null;

          var targetVersion = cartPreviewState.version;

          if (
            selectedConfig.previewBlob &&
            cartPreviewState.builtVersion === targetVersion
          ) {
            return selectedConfig.previewBlob;
          }

          if (cartPreviewState.promise) {
            return cartPreviewState.promise;
          }

          cartPreviewState.promise = (async function() {
            try {
              await buildPosterFilesForUpload();

              /*
               * Falls der Kunde während des Renderns noch etwas geändert hat,
               * ist dieses Ergebnis veraltet und darf später nicht benutzt werden.
               */
              if (cartPreviewState.version !== targetVersion) {
                selectedConfig.previewBlob = null;
                cartPreviewState.builtVersion = -1;
                return null;
              }

              cartPreviewState.builtVersion = targetVersion;
              return selectedConfig.previewBlob;
            } catch (error) {
              console.warn('Cart-Preview konnte nicht vorab erstellt werden.', error);
              return null;
            } finally {
              cartPreviewState.promise = null;
            }
          })();

          return cartPreviewState.promise;
        }

        async function ensureCartPreviewReady() {
          var currentVersion = cartPreviewState.version;

          if (
            selectedConfig.previewBlob &&
            cartPreviewState.builtVersion === currentVersion
          ) {
            return selectedConfig.previewBlob;
          }

          if (cartPreviewState.promise) {
            await cartPreviewState.promise;

            if (
              selectedConfig.previewBlob &&
              cartPreviewState.builtVersion === cartPreviewState.version
            ) {
              return selectedConfig.previewBlob;
            }
          }

          /*
           * Falls der Kunde sehr schnell auf den Button klickt und das
           * Background-Rendering noch nicht lief, erstellen wir es jetzt.
           */
          var targetVersion = cartPreviewState.version;

          await buildPosterFilesForUpload();

          if (cartPreviewState.version !== targetVersion) {
            /*
             * Sehr seltener Fall: Zustand hat sich währenddessen verändert.
             * Einmal mit dem neuesten Zustand neu erzeugen.
             */
            selectedConfig.previewBlob = null;
            targetVersion = cartPreviewState.version;
            await buildPosterFilesForUpload();
          }

          cartPreviewState.builtVersion = targetVersion;
          return selectedConfig.previewBlob;
        }

        var cropState = {
        naturalWidth: 0,
        naturalHeight: 0,
        rotation: 0,
        zoom: 1,
        x: 0,
        y: 0,
        baseWidth: 0,
        baseHeight: 0,
        dragging: false,
        startX: 0,
        startY: 0,
        dragOriginX: 0,
        dragOriginY: 0
      };

        function getHeaderSelectionText() {
  var size = selectedConfig.sizeLabel || '';
  var frameLabel = selectedConfig.frameLabel || '';
  var normalizedFrame = String(frameLabel).toLowerCase().trim();

  var isNoFrame =
    normalizedFrame === 'weiter ohne rahmen' ||
    normalizedFrame === 'continue without frame' ||
    normalizedFrame === 'fortsæt uden ramme' ||
    normalizedFrame === 'continuar sin marco' ||
    normalizedFrame === 'continuer sans cadre' ||
    normalizedFrame === 'continua senza cornice' ||
    normalizedFrame === 'fortsett uten ramme' ||
    normalizedFrame === 'fortsätt utan ram' ||
    normalizedFrame === 'doorgaan zonder frame';

  if (size && frameLabel && !isNoFrame) {
    return ' (' + size + ' - ' + frameLabel + ')';
  }

  if (size) {
    return ' (' + size + ')';
  }

  return '';
}

        function setHeaderForStep(step) {
  currentStep = step;

  headerTitle.textContent = getHeaderSelectionText().replace(/^\s*/, '');

  if (step === 'upload') {
    backBtn.classList.add('is-hidden');
    changeImageBtn.classList.add('is-hidden');
  } else if (step === 'crop') {
    backBtn.classList.remove('is-hidden');
    changeImageBtn.classList.add('is-hidden');
  } else {
    backBtn.classList.remove('is-hidden');
    changeImageBtn.classList.remove('is-hidden');
  }
}

      function showStep(stepEl, stepName) {
        [stepUpload, stepCrop, stepCustomize].forEach(function (el) {
          if (el) el.classList.add('is-hidden');
        });

        if (stepEl) stepEl.classList.remove('is-hidden');
        setHeaderForStep(stepName);

        if (stepName === 'crop' && cropState.naturalWidth) {
          requestAnimationFrame(fitImageToStage);
        }
      }

      function getCurrentProductSelection() {
  var form = document.getElementById(PRODUCT_FORM_ID);
  if (!form) return null;

  var variantField = form.querySelector('[name="id"]');
  var values = [];

  var checkedRadios = document.querySelectorAll(
    'input[type="radio"][form="' + PRODUCT_FORM_ID + '"]:checked'
  );

  if (checkedRadios.length) {
    checkedRadios.forEach(function(input) {
      values.push((input.value || '').trim());
    });
  } else {
    var selects = form.querySelectorAll('select');
    selects.forEach(function(select) {
      var selectedText = '';
      if (select.options && select.selectedIndex >= 0) {
        selectedText = select.options[select.selectedIndex].text || select.value || '';
      } else {
        selectedText = select.value || '';
      }
      values.push(String(selectedText).trim());
    });
  }

  return {
    variantId: variantField ? String(variantField.value) : '',
    sizeLabel: values[0] || '',
    frameLabel: values[1] || ''
  };
}

      function normalizeMetricSize(value) {
        var text = String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
        var match = text.match(/(\d+)\s*x\s*(\d+)\s*cm/);

        if (!match) return '';
        return match[1] + 'x' + match[2] + ' cm';
      }

      function getFrameVariantId(sizeLabel, frameLabel) {
        var key = String(sizeLabel || '').trim() + '|' + String(frameLabel || '').trim();

        if (Object.prototype.hasOwnProperty.call(frameMap, key)) {
          return frameMap[key];
        }

        console.warn('Kein frameMap-Treffer für:', key);
        return null;
      }

      function applySizeConfig(sizeKey) {
        var config = SIZE_CONFIG[sizeKey] || SIZE_CONFIG['30x40 cm'];

        selectedConfig.sizeKey = sizeKey;
        selectedConfig.exportWidth = config.exportWidth;
        selectedConfig.exportHeight = config.exportHeight;
        selectedConfig.previewWidth = config.previewWidth;
        selectedConfig.ratioCss = config.ratioCss;

        modal.style.setProperty('--ps-preview-max-width', config.previewWidth + 'px');
        modal.style.setProperty('--ps-poster-ratio', config.ratioCss);
      }

    function syncPreviewFrameButtons(frameStyle) {
  frameButtons.forEach(function(btn) {
    btn.classList.toggle('is-active', btn.getAttribute('data-frame-option') === frameStyle);
  });
}

function syncPreviewFontButtons(fontStyle) {
  fontButtons.forEach(function(btn) {
    btn.classList.toggle('is-active', btn.getAttribute('data-font-option') === fontStyle);
  });
}

function applyFontConfig() {
  if (previewTextWrap) {
    previewTextWrap.setAttribute('data-font-style', selectedConfig.fontStyle || 'modern');
  }

  syncPreviewFontButtons(selectedConfig.fontStyle || 'modern');
}

function getProductFrameStyle(frameLabel) {
  var label = String(frameLabel || '').toLowerCase().trim();

  if (
    label.indexOf('holz eiche') !== -1 ||
    label.indexOf('premium oak') !== -1 ||
    label.indexOf('premium eg') !== -1 ||
    label.indexOf('premium chêne') !== -1 ||
    label.indexOf('premium rovere') !== -1 ||
    label.indexOf('premium eik') !== -1 ||
    label.indexOf('premium ek') !== -1 ||
    label.indexOf('premium eiken') !== -1 ||
    label.indexOf('premium roble') !== -1
  ) {
    return 'oak';
  }

  if (
    label.indexOf('holz weiß') !== -1 ||
    label.indexOf('holz weiss') !== -1 ||
    label.indexOf('premium wood white') !== -1 ||
    label.indexOf('premium hvid') !== -1 ||
    label.indexOf('premium blanco') !== -1 ||
    label.indexOf('premium blanc') !== -1 ||
    label.indexOf('premium bianco') !== -1 ||
    label.indexOf('premium hvit') !== -1 ||
    label.indexOf('premium vit') !== -1 ||
    label.indexOf('premium wit') !== -1
  ) {
    return 'white-product';
  }

  if (
    label.indexOf('holz schwarz') !== -1 ||
    label.indexOf('premium wood black') !== -1 ||
    label.indexOf('premium sort') !== -1 ||
    label.indexOf('premium negro') !== -1 ||
    label.indexOf('premium noir') !== -1 ||
    label.indexOf('premium nero') !== -1 ||
    label.indexOf('premium svart') !== -1 ||
    label.indexOf('premium zwart') !== -1
  ) {
    return 'black-product';
  }

  return 'none';
}

function applyProductFrameOverlay(productFrameStyle) {
  selectedConfig.productFrameStyle = productFrameStyle || 'none';

  if (previewOuter) {
    previewOuter.setAttribute('data-product-frame', selectedConfig.productFrameStyle);
  }
}

function applyFrameConfig() {
  if (frame) {
    frame.setAttribute('data-frame-style', selectedConfig.frameStyle);
  }

  if (previewTextWrap) {
    previewTextWrap.setAttribute('data-font-style', selectedConfig.fontStyle || 'modern');
  }

  syncPreviewFrameButtons(selectedConfig.frameStyle);
  syncPreviewFontButtons(selectedConfig.fontStyle || 'modern');
  applyProductFrameOverlay(selectedConfig.productFrameStyle);
}

      function updateSelectionTexts() {
        var exportText = selectedConfig.exportWidth && selectedConfig.exportHeight
          ? selectedConfig.exportWidth + ' × ' + selectedConfig.exportHeight + ' px'
          : '–';

        if (selectedSizeUpload) selectedSizeUpload.textContent = selectedConfig.sizeLabel || '–';
        if (selectedFrameUpload) selectedFrameUpload.textContent = selectedConfig.frameLabel || '–';
        if (exportSizeUpload) exportSizeUpload.textContent = exportText;

        if (selectedSizeCrop) selectedSizeCrop.textContent = selectedConfig.sizeLabel || '–';
        if (selectedFrameCrop) selectedFrameCrop.textContent = selectedConfig.frameLabel || '–';
        if (exportSizeCrop) exportSizeCrop.textContent = exportText;

        if (selectedSizeCustomize) selectedSizeCustomize.textContent = selectedConfig.sizeLabel || '–';
        if (selectedFrameCustomize) selectedFrameCustomize.textContent = selectedConfig.frameLabel || '–';
        if (exportSizeCustomize) exportSizeCustomize.textContent = exportText;
      }

          function syncSizeButtons() {
        sizeButtons.forEach(function(btn) {
          var value = (btn.getAttribute('data-size-option') || '').trim();
          btn.classList.toggle('is-active', value === (selectedConfig.sizeLabel || '').trim());
        });
      }

      function isMobileCustomSizeView() {
  return window.matchMedia('(max-width: 768px)').matches;
}

function openCustomSizePicker() {
  if (!customSizePicker) return;

  customSizePicker.classList.add('is-open');

  if (customSizeTrigger) {
    customSizeTrigger.setAttribute('aria-expanded', 'true');
  }

  if (isMobileCustomSizeView()) {
    if (customSizeSheet) {
      customSizeSheet.hidden = false;
    }
    if (customSizeDropdown) {
      customSizeDropdown.hidden = true;
    }
    document.body.classList.add('custom-size-sheet-open');
  } else {
    if (customSizeDropdown) {
      customSizeDropdown.hidden = false;
    }
    if (customSizeSheet) {
      customSizeSheet.hidden = true;
    }
  }
}

function closeCustomSizePicker() {
  if (!customSizePicker) return;

  customSizePicker.classList.remove('is-open');

  if (customSizeTrigger) {
    customSizeTrigger.setAttribute('aria-expanded', 'false');
  }

  if (customSizeDropdown) {
    customSizeDropdown.hidden = true;
  }

  if (customSizeSheet) {
    customSizeSheet.hidden = true;
  }

  document.body.classList.remove('custom-size-sheet-open');
}

function syncCustomSizePicker() {
  var activeSize = (selectedConfig.sizeLabel || '').trim();

  if (customSizeTriggerText) {
    customSizeTriggerText.textContent = activeSize || '';
  }

  customSizeOptions.forEach(function(option) {
    var value = (option.getAttribute('data-custom-size-value') || '').trim();
    option.classList.toggle('is-active', value === activeSize);
  });
}

      function findSizeInputByValue(sizeValue) {
        var safeValue = String(sizeValue || '').trim();
        if (!safeValue) return null;

        var selector = 'input[type="radio"][form="' + PRODUCT_FORM_ID + '"]';
        var inputs = document.querySelectorAll(selector);

        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if ((input.value || '').trim() === safeValue) {
            return input;
          }
        }

        return null;
      }

      function changeShopifySize(sizeValue) {
        var targetInput = findSizeInputByValue(sizeValue);
        if (!targetInput || targetInput.disabled) return false;

        targetInput.checked = true;
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        targetInput.dispatchEvent(new Event('input', { bubbles: true }));

        var relatedLabel = document.querySelector('label[for="' + targetInput.id + '"]');
        if (relatedLabel) {
          relatedLabel.click();
        }

        return true;
      }

      function handleSizeChange(sizeValue) {
  if (!sizeValue) return;

  var changed = changeShopifySize(sizeValue);
  if (!changed) return;

  selectedConfig.sizeLabel = String(sizeValue).trim();

  syncSizeButtons();
  syncCustomSizePicker();
  updateCustomFrameCardPrices();
  closeCustomSizePicker();

  window.setTimeout(function() {
    var ok = syncSelectionFromShopify();
    if (!ok) return;

    syncSizeButtons();
    syncCustomSizePicker();
    syncCustomFrameCards();
    updateCustomFrameCardPrices();
    setHeaderForStep(currentStep);
    markCartPreviewDirty(true);

    if (cropState.naturalWidth) {
      requestAnimationFrame(function () {
        fitImageToStage();
        updateQualityIndicator();
      });
    }
  }, 220);
}

      function syncProductFrameButtons() {
        productFrameButtons.forEach(function(btn) {
          var value = (btn.getAttribute('data-product-frame-option') || '').trim();
          btn.classList.toggle('is-active', value === (selectedConfig.frameLabel || '').trim());
        });
      }
      function syncCustomFrameCards() {
  customFrameCards.forEach(function(card) {
    var value = (card.getAttribute('data-custom-frame-value') || '').trim();
    card.classList.toggle('is-active', value === (selectedConfig.frameLabel || '').trim());
  });
}

      function findFrameInputByValue(frameValue) {
        var safeValue = String(frameValue || '').trim();
        if (!safeValue) return null;

        var selector = 'input[type="radio"][form="' + PRODUCT_FORM_ID + '"]';
        var inputs = document.querySelectorAll(selector);

        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if ((input.value || '').trim() === safeValue) {
            return input;
          }
        }

        return null;
      }

      function changeShopifyFrame(frameValue) {
        var targetInput = findFrameInputByValue(frameValue);
        if (!targetInput || targetInput.disabled) return false;

        targetInput.checked = true;
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        targetInput.dispatchEvent(new Event('input', { bubbles: true }));

        var relatedLabel = document.querySelector('label[for="' + targetInput.id + '"]');
        if (relatedLabel) {
          relatedLabel.click();
        }

        return true;
      }

      function handleProductFrameChange(frameValue) {
        if (!frameValue) return;

        var changed = changeShopifyFrame(frameValue);
        if (!changed) return;

        window.setTimeout(function() {
  var ok = syncSelectionFromShopify();
  if (!ok) return;

  syncSizeButtons();
  syncProductFrameButtons();
  syncCustomFrameCards();
  setHeaderForStep(currentStep);
  markCartPreviewDirty(true);

  if (cropState.naturalWidth) {
    requestAnimationFrame(function () {
      fitImageToStage();
      updateQualityIndicator();
    });
  }
}, 120);

refreshCustomFramePricesDelayed(220);
      }

      function syncSelectionFromShopify() {
        var selection = getCurrentProductSelection();

        if (!selection || !selection.variantId || !selection.sizeLabel) {
          alert('Bitte wählen Sie zuerst eine Größe aus.');
          return false;
        }

        var sizeKey = normalizeMetricSize(selection.sizeLabel);

        if (!SIZE_CONFIG[sizeKey]) {
          alert('Diese Größe wird aktuell nicht unterstützt.');
          return false;
        }

        selectedConfig.posterVariantId = selection.variantId;
        selectedConfig.sizeLabel = selection.sizeLabel;
        selectedConfig.frameLabel = selection.frameLabel || '';
        selectedConfig.frameVariantId = getFrameVariantId(selection.sizeLabel, selection.frameLabel);
        selectedConfig.productFrameStyle = getProductFrameStyle(selection.frameLabel);
        selectedConfig.frameStyle = selectedConfig.frameStyle || 'white';
        selectedConfig.fontStyle = selectedConfig.fontStyle || 'modern';

        applySizeConfig(sizeKey);
applyFontConfig();
applyFrameConfig();
updateSelectionTexts();
syncSizeButtons();
syncCustomSizePicker();
syncProductFrameButtons();
syncCustomFrameCards();

return true;
      }

            function updatePreviewText() {
        var v1 = input1 ? input1.value.trim() : '';
        var v2 = input2 ? input2.value.trim() : '';

        if (preview1) preview1.textContent = v1;
        if (preview2) preview2.textContent = v2;

        if (previewTextWrap) {
          previewTextWrap.classList.toggle('is-hidden', !v1 && !v2);
        }
      }

      function setPrimaryActionLabel(text) {
        if (!primaryActionBtn) return;

        if (primaryActionLabel) {
          primaryActionLabel.textContent = text || '';
        } else {
          /*
           * Falls kein separates Label-Element existiert, achten wir darauf,
           * einen vorhandenen Spinner nicht zu löschen.
           */
          var fallbackLabel = primaryActionBtn.querySelector('[data-personalised-fallback-label]');

          if (!fallbackLabel) {
            fallbackLabel = document.createElement('span');
            fallbackLabel.setAttribute('data-personalised-fallback-label', '');
            primaryActionBtn.appendChild(fallbackLabel);
          }

          fallbackLabel.textContent = text || '';
        }
      }

      function ensurePrimaryActionLoadingUi() {
        if (!primaryActionBtn) return;

        if (!document.getElementById('ps-primary-loading-style')) {
          var style = document.createElement('style');
          style.id = 'ps-primary-loading-style';
          style.textContent = [
            '#personalisedPrimaryActionBtn{position:relative;}',
            '#personalisedPrimaryActionBtn .ps-primary-spinner{',
            'display:none;',
            'width:14px;',
            'height:14px;',
            'margin-right:9px;',
            'vertical-align:-2px;',
            'border:1.5px solid currentColor;',
            'border-right-color:transparent;',
            'border-radius:50%;',
            'animation:psPrimarySpin .65s linear infinite;',
            'box-sizing:border-box;',
            '}',
            '#personalisedPrimaryActionBtn[aria-busy="true"] .ps-primary-spinner{display:inline-block;}',
            '#personalisedPrimaryActionBtn[aria-busy="true"]{cursor:wait;}',
            '@keyframes psPrimarySpin{to{transform:rotate(360deg);}}'
          ].join('');
          document.head.appendChild(style);
        }

        if (!primaryActionBtn.querySelector('.ps-primary-spinner')) {
          var spinner = document.createElement('span');
          spinner.className = 'ps-primary-spinner';
          spinner.setAttribute('aria-hidden', 'true');

          if (primaryActionLabel) {
            primaryActionBtn.insertBefore(spinner, primaryActionLabel);
          } else {
            primaryActionBtn.insertBefore(spinner, primaryActionBtn.firstChild);
          }
        }
      }

      function setPrimaryActionLoading(isLoading) {
        if (!primaryActionBtn) return;

        ensurePrimaryActionLoadingUi();

        primaryActionBtn.disabled = !!isLoading;

        if (isLoading) {
          primaryActionBtn.setAttribute('aria-busy', 'true');
          setPrimaryActionLabel(addToCartLoadingLabel);
        } else {
          primaryActionBtn.removeAttribute('aria-busy');
          updatePrimaryActionState(currentEditorTab);
        }
      }

      function waitForUiPaint() {
        return new Promise(function(resolve) {
          window.requestAnimationFrame(function() {
            window.requestAnimationFrame(resolve);
          });
        });
      }

      function updatePrimaryActionState(tabName) {
        if (tabName) currentEditorTab = tabName;
        if (!primaryActionBtn) return;

        var lastFlowStep = editorFlow.length ? editorFlow[editorFlow.length - 1] : 'size';
        var isFinalStep = currentEditorTab === lastFlowStep;

        primaryActionBtn.setAttribute('data-action', isFinalStep ? 'add-to-cart' : 'next');
        primaryActionBtn.setAttribute('aria-label', isFinalStep ? addToCartLabel : continueLabel);
        setPrimaryActionLabel(isFinalStep ? addToCartLabel : continueLabel);
      }

      function switchEditorTab(tabName) {
        currentEditorTab = tabName || currentEditorTab;

        editorTabs.forEach(function(tab) {
          tab.classList.toggle('is-active', tab.getAttribute('data-editor-tab') === currentEditorTab);
        });

        editorPanels.forEach(function(panel) {
          panel.classList.toggle('is-hidden', panel.getAttribute('data-editor-panel') !== currentEditorTab);
        });

        updatePrimaryActionState(currentEditorTab);

        if (isFinalEditorStep() && selectedConfig.previewDataUrl) {
          /*
           * Auf Handy etwas früher vorbereiten, damit beim finalen Klick
           * normalerweise gar kein html2canvas mehr nötig ist.
           */
          var mobilePrebuild =
            window.matchMedia &&
            window.matchMedia('(max-width: 768px)').matches;

          scheduleCartPreviewPrebuild(
            mobilePrebuild ? 80 : 220
          );
        }
      }

      function goToNextEditorStep() {
        if (!editorFlow.length) return;

        var currentIndex = editorFlow.indexOf(currentEditorTab);

        if (currentIndex === -1) {
          switchEditorTab(editorFlow[0]);
          switchEditorCanvas('preview');
          return;
        }

        if (currentIndex >= editorFlow.length - 1) {
          addToCart();
          return;
        }

        var nextTab = editorFlow[currentIndex + 1];
        switchEditorTab(nextTab);
        switchEditorCanvas('preview');

        var activePanel = personalisedRoot.querySelector('[data-editor-panel="' + nextTab + '"]');
        if (activePanel && typeof activePanel.scrollIntoView === 'function' && window.innerWidth <= 900) {
          activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      function switchEditorCanvas(mode) {
        var showCrop = mode === 'crop';

        if (editorCropWrap) {
          editorCropWrap.classList.toggle('is-hidden', !showCrop);
        }

        if (editorPreviewWrap) {
          editorPreviewWrap.classList.toggle('is-hidden', showCrop);
        }

        if (editorFooter) {
          editorFooter.classList.toggle('is-hidden', showCrop);
        }

        if (showCrop && cropState.naturalWidth) {
          requestAnimationFrame(function () {
            fitImageToStage();
            updateQualityIndicator();
          });
        }
      }

      function setCropDirty(isDirty) {
        cropDirty = !!isDirty;

        if (!cropConfirmBtn) return;

        cropConfirmBtn.style.display = cropDirty ? '' : 'none';
      }

      function markCropAsChanged() {
        if (!selectedConfig.uploadFile) return;

        selectedConfig.cropData = null;
        selectedConfig.printKey = '';
        selectedConfig.printUrl = '';
        selectedConfig.designKey = '';
        selectedConfig.designUrl = '';
        resetCartPreviewCache();

        setCropDirty(true);
      }
      
                  frameButtons.forEach(function (btn) {
  btn.addEventListener('click', function () {
    var selected = btn.getAttribute('data-frame-option');
    if (!selected || !frame) return;

    selectedConfig.frameStyle = selected;
    selectedConfig.printKey = '';
    selectedConfig.printUrl = '';
    selectedConfig.designKey = '';
    selectedConfig.designUrl = '';
    applyFrameConfig();
    markCartPreviewDirty(true);
  });
});

         fontButtons.forEach(function (btn) {
  btn.addEventListener('click', function () {
    var selected = btn.getAttribute('data-font-option');
    if (!selected) return;

    selectedConfig.fontStyle = selected;
    selectedConfig.printKey = '';
    selectedConfig.printUrl = '';
    selectedConfig.designKey = '';
    selectedConfig.designUrl = '';
    applyFontConfig();
    applyFrameConfig();
    markCartPreviewDirty(true);
  });
});

      editorTabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var tabName = tab.getAttribute('data-editor-tab');
          if (!tabName) return;

          if (tabName === 'crop') {
            if (!selectedConfig.uploadFile || !cropState.naturalWidth) return;
            showStep(stepCustomize, 'crop');
            switchEditorTab('crop');
            switchEditorCanvas('crop');
            setCropDirty(cropDirty);
            return;
          }

          if (!selectedConfig.previewDataUrl) return;

          showStep(stepCustomize, 'customize');
          switchEditorTab(tabName);
          switchEditorCanvas('preview');
        });
      });

      sizeButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.disabled || btn.classList.contains('is-disabled')) return;

          var sizeValue = btn.getAttribute('data-size-option');
          handleSizeChange(sizeValue);
        });
      });

      if (customSizeTrigger) {
  customSizeTrigger.addEventListener('click', function() {
    if (customSizePicker && customSizePicker.classList.contains('is-open')) {
      closeCustomSizePicker();
    } else {
      openCustomSizePicker();
    }
  });
}

customSizeOptions.forEach(function(option) {
  option.addEventListener('click', function() {
    if (option.disabled || option.classList.contains('is-disabled')) return;

    var sizeValue = option.getAttribute('data-custom-size-value');
    handleSizeChange(sizeValue);
  });
});

customSizeCloseButtons.forEach(function(btn) {
  btn.addEventListener('click', function() {
    closeCustomSizePicker();
  });
});

document.addEventListener('click', function(event) {
  if (!customSizePicker) return;
  if (isMobileCustomSizeView()) return;
  if (customSizePicker.contains(event.target)) return;

  closeCustomSizePicker();
});

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeCustomSizePicker();
  }
});

window.addEventListener('resize', function() {
  closeCustomSizePicker();
});

      productFrameButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.disabled || btn.classList.contains('is-disabled')) return;

          var frameValue = btn.getAttribute('data-product-frame-option');
          handleProductFrameChange(frameValue);
        });
      });
      customFrameCards.forEach(function(card) {
  card.addEventListener('click', function() {
    if (card.disabled || card.classList.contains('is-disabled')) return;

    var frameValue = card.getAttribute('data-custom-frame-value');
    handleProductFrameChange(frameValue);
  });
});

      function getDisplayedImageBounds() {
        var rotated = cropState.rotation % 180 !== 0;
        var zoomedWidth = cropState.baseWidth * cropState.zoom;
        var zoomedHeight = cropState.baseHeight * cropState.zoom;

        return {
          width: rotated ? zoomedHeight : zoomedWidth,
          height: rotated ? zoomedWidth : zoomedHeight
        };
      }

      function clampCropOffset() {
        if (!cropStage) return;

        var stageRect = cropStage.getBoundingClientRect();
        var bounds = getDisplayedImageBounds();

        var maxX = Math.max(0, (bounds.width - stageRect.width) / 2);
        var maxY = Math.max(0, (bounds.height - stageRect.height) / 2);

        cropState.x = Math.min(maxX, Math.max(-maxX, cropState.x));
        cropState.y = Math.min(maxY, Math.max(-maxY, cropState.y));
      }

        function applyCropTransform() {
        if (!cropImage) return;

        clampCropOffset();

        cropImage.style.width = (cropState.baseWidth * cropState.zoom) + 'px';
        cropImage.style.height = (cropState.baseHeight * cropState.zoom) + 'px';
        cropImage.style.transform =
          'translate(-50%, -50%) translate(' + cropState.x + 'px, ' + cropState.y + 'px) rotate(' + cropState.rotation + 'deg)';
      }

      function getRotatedNaturalSize() {
        var rotated = cropState.rotation % 180 !== 0;

        return {
          width: rotated ? cropState.naturalHeight : cropState.naturalWidth,
          height: rotated ? cropState.naturalWidth : cropState.naturalHeight
        };
      }

      function fitImageToStage() {
        if (!cropStage || !cropState.naturalWidth || !cropState.naturalHeight) return;

        var rect = cropStage.getBoundingClientRect();
        var rotated = getRotatedNaturalSize();
        var scale = Math.max(rect.width / rotated.width, rect.height / rotated.height);

        cropState.baseWidth = cropState.naturalWidth * scale;
        cropState.baseHeight = cropState.naturalHeight * scale;
        cropState.zoom = 1;
        cropState.x = 0;
        cropState.y = 0;

        if (zoomRange) {
  zoomRange.value = '100';
  updateZoomRangeProgress();
}

applyCropTransform();
      }

      function resetCropState() {
  cropState.naturalWidth = 0;
  cropState.naturalHeight = 0;
  cropState.rotation = 0;
  cropState.zoom = 1;
  cropState.x = 0;
  cropState.y = 0;
  cropState.baseWidth = 0;
  cropState.baseHeight = 0;
  cropState.dragging = false;
  cropState.startX = 0;
  cropState.startY = 0;
  cropState.dragOriginX = 0;
  cropState.dragOriginY = 0;
}

function updateQualityIndicator() {
  if (!qualityFill || !qualityText) return;
  if (!cropState.naturalWidth || !cropState.naturalHeight) return;
  if (!selectedConfig.exportWidth || !selectedConfig.exportHeight) return;

  var ratioW = cropState.naturalWidth / selectedConfig.exportWidth;
  var ratioH = cropState.naturalHeight / selectedConfig.exportHeight;
  var percent = Math.round(Math.max(0, Math.min(1, Math.min(ratioW, ratioH))) * 100);

  var displayPercent = percent;

  if (percent >= 40) {
    displayPercent = 100;
    qualityFill.style.backgroundColor = '#4CAF50';
    qualityText.textContent = qualityGoodLabel;
  } else if (percent >= 20) {
    displayPercent = 66;
    qualityFill.style.backgroundColor = '#F4B400';
    qualityText.textContent = qualityMediumLabel;
  } else {
    displayPercent = 33;
    qualityFill.style.backgroundColor = '#E53935';
    qualityText.textContent = qualityBadLabel;
  }

  qualityFill.style.width = displayPercent + '%';
}


      function roundCropValue(value) {
        return Math.round(Number(value || 0) * 1000000) / 1000000;
      }

      function getNormalizedCropData() {
        if (!cropStage || !cropState.naturalWidth || !cropState.naturalHeight) {
          return null;
        }

        clampCropOffset();

        var stageRect = cropStage.getBoundingClientRect();
        var stageWidth = Number(stageRect.width || 0);
        var stageHeight = Number(stageRect.height || 0);
        var bounds = getDisplayedImageBounds();

        if (!stageWidth || !stageHeight || !bounds.width || !bounds.height) {
          return selectedConfig.cropData || null;
        }

        var left = (bounds.width / 2 - stageWidth / 2 - cropState.x) / bounds.width;
        var top = (bounds.height / 2 - stageHeight / 2 - cropState.y) / bounds.height;
        var width = stageWidth / bounds.width;
        var height = stageHeight / bounds.height;

        left = Math.max(0, Math.min(1, left));
        top = Math.max(0, Math.min(1, top));
        width = Math.max(0.000001, Math.min(1 - left, width));
        height = Math.max(0.000001, Math.min(1 - top, height));

        return {
          left: roundCropValue(left),
          top: roundCropValue(top),
          width: roundCropValue(width),
          height: roundCropValue(height),
          rotation: Number(cropState.rotation || 0)
        };
      }

      function renderCropToPreview() {
        if (!cropImage || !previewImage || !cropStage) return;
        if (!selectedConfig.exportWidth || !selectedConfig.exportHeight) return;

        clampCropOffset();

        var stageRect = cropStage.getBoundingClientRect();
        var stageWidth = Math.max(1, Math.round(stageRect.width));
        var stageHeight = Math.max(1, Math.round(stageRect.height));

        selectedConfig.cropData = getNormalizedCropData();

        if (!selectedConfig.cropData) {
          alert('Der Bildausschnitt konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
          return;
        }

        // Browser: nur Vorschau. Volle Druckauflösung macht das B2B-Backend.
        var previewMaxEdge = 1800;
        var previewScale = Math.min(
          1,
          previewMaxEdge / Math.max(selectedConfig.exportWidth, selectedConfig.exportHeight)
        );

        var previewCanvasWidth = Math.max(
          1,
          Math.round(selectedConfig.exportWidth * previewScale)
        );
        var previewCanvasHeight = Math.max(
          1,
          Math.round(selectedConfig.exportHeight * previewScale)
        );

        var canvas = document.createElement('canvas');
        canvas.width = previewCanvasWidth;
        canvas.height = previewCanvasHeight;

        var ctx = canvas.getContext('2d');
        if (!ctx) return;

        var scaleX = canvas.width / stageWidth;
        var scaleY = canvas.height / stageHeight;
        var drawWidth = (cropState.baseWidth * cropState.zoom) * scaleX;
        var drawHeight = (cropState.baseHeight * cropState.zoom) * scaleY;

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.save();
        ctx.translate(
          canvas.width / 2 + cropState.x * scaleX,
          canvas.height / 2 + cropState.y * scaleY
        );
        ctx.rotate(cropState.rotation * Math.PI / 180);
        ctx.drawImage(
          cropImage,
          -drawWidth / 2,
          -drawHeight / 2,
          drawWidth,
          drawHeight
        );
        ctx.restore();

        selectedConfig.previewDataUrl = canvas.toDataURL('image/jpeg', 0.92);
        previewImage.src = selectedConfig.previewDataUrl;

        applyFontConfig();
        applyFrameConfig();
        setCropDirty(false);
        showStep(stepCustomize, 'customize');
        switchEditorTab('text');
        switchEditorCanvas('preview');

        /*
         * Neue Crop-Vorschau = neue Cart-Preview.
         */
        markCartPreviewDirty(false);

        /*
         * Der Original-Upload wurde bereits direkt nach Bildauswahl gestartet.
         * Dieser Aufruf ist nur ein sicherer Fallback und startet keinen
         * doppelten Upload, wenn er schon läuft.
         */
        startOriginalUploadEarly();
      }

     function renderPosterCanvas(targetWidth, targetHeight) {
  if (!previewImage || !previewImage.src) return null;
  if (!targetWidth || !targetHeight) return null;

  var canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;

  var ctx = canvas.getContext('2d');
  if (!ctx) return null;

  var borderMode = selectedConfig.frameStyle === 'none' ? 'none' : 'white';

  var outerMarginX = borderMode === 'white' ? Math.round(targetWidth * 0.06) : 0;
  var outerMarginTop = borderMode === 'white' ? Math.round(targetHeight * 0.05) : 0;
  var textAreaHeight = Math.round(targetHeight * 0.16);
  var outerMarginBottom = borderMode === 'white'
    ? Math.round(targetHeight * 0.05)
    : Math.round(targetHeight * 0.03);

  var imageAreaX = outerMarginX;
  var imageAreaY = outerMarginTop;
  var imageAreaWidth = targetWidth - outerMarginX * 2;
  var imageAreaHeight = targetHeight - outerMarginTop - textAreaHeight - outerMarginBottom;

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(
    previewImage,
    imageAreaX,
    imageAreaY,
    imageAreaWidth,
    imageAreaHeight
  );

  var text1 = preview1 ? preview1.textContent.trim() : '';
  var text2 = preview2 ? preview2.textContent.trim() : '';

  var textCenterX = targetWidth / 2;
  var textBlockTop = imageAreaY + imageAreaHeight + Math.round(targetHeight * 0.04);

  if (text1) {
    ctx.fillStyle = '#111111';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.font = '600 ' + Math.round(targetHeight * 0.038) + 'px Arial';
    ctx.fillText(text1, textCenterX, textBlockTop);
  }

  if (text2) {
    ctx.fillStyle = '#444444';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.font = '400 ' + Math.round(targetHeight * 0.022) + 'px Arial';
    ctx.fillText(
      text2,
      textCenterX,
      textBlockTop + Math.round(targetHeight * 0.05)
    );
  }

  return canvas;
}


async function buildPosterFilesForUpload() {
  if (!previewOuter) {
    throw new Error('Preview-Element nicht gefunden');
  }

  if (typeof html2canvas !== 'function') {
    throw new Error('html2canvas ist nicht geladen');
  }

  /*
   * EXAKTE CART-PREVIEW
   *
   * Wir fotografieren wieder die echte sichtbare Shopify-Preview.
   * Dadurch stimmen physischer Rahmen, innerer Rand, Bildposition,
   * Text und alle Abstände exakt wie im Editor.
   *
   * Auf Handy reduzieren wir nur die Render-Auflösung.
   * Das ist deutlich leichter als früher, ohne die Geometrie selbst
   * manuell nachzubauen.
   */
  var isMobilePreview =
    window.matchMedia &&
    window.matchMedia('(max-width: 768px)').matches;

  var previewScale =
    isMobilePreview
      ? 0.65
      : 1;

  var posterCanvas =
    await html2canvas(
      previewOuter,
      {
        backgroundColor: null,
        scale: previewScale,
        useCORS: true,
        logging: false,

        /*
         * Verhindert unnötige Scroll-/Viewport-Berechnungen auf Safari.
         */
        scrollX: 0,
        scrollY: -window.scrollY,

        /*
         * SVG/Webfont/Shopify-CDN Inhalte dürfen vorher laden.
         */
        imageTimeout: 5000
      }
    );

  if (!posterCanvas) {
    throw new Error(
      'Preview-Datei konnte nicht erstellt werden'
    );
  }

  var exportCanvas = document.createElement('canvas');
  exportCanvas.width = 1100;
  exportCanvas.height = 1100;

  var ctx = exportCanvas.getContext('2d');
  if (!ctx) {
    throw new Error('Preview-Datei konnte nicht erstellt werden');
  }

  ctx.fillStyle = '#fafafa';
  ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

  var maxPosterWidth = 620;
  var maxPosterHeight = 860;

  var scale = Math.min(
    maxPosterWidth / posterCanvas.width,
    maxPosterHeight / posterCanvas.height
  );

  var drawWidth = Math.round(posterCanvas.width * scale);
  var drawHeight = Math.round(posterCanvas.height * scale);

  var drawX = Math.round((exportCanvas.width - drawWidth) / 2);
  var drawY = Math.round((exportCanvas.height - drawHeight) / 2);

  ctx.drawImage(
    posterCanvas,
    drawX,
    drawY,
    drawWidth,
    drawHeight
  );

  selectedConfig.previewBlob = await new Promise(function(resolve) {
    exportCanvas.toBlob(function(blob) {
      resolve(blob || null);
    }, 'image/jpeg', 0.92);
  });

  selectedConfig.printBlob = null;

  if (!selectedConfig.previewBlob) {
    throw new Error('Preview-Datei konnte nicht erstellt werden');
  }
}

      function pointerDown(x, y) {
        cropState.dragging = true;
        cropState.startX = x;
        cropState.startY = y;
        cropState.dragOriginX = cropState.x;
        cropState.dragOriginY = cropState.y;

        if (cropStage) cropStage.classList.add('is-dragging');
      }

      function pointerMove(x, y) {
        if (!cropState.dragging) return;

        cropState.x = cropState.dragOriginX + (x - cropState.startX);
        cropState.y = cropState.dragOriginY + (y - cropState.startY);

        applyCropTransform();
        markCropAsChanged();
      }

      function pointerUp() {
        cropState.dragging = false;
        if (cropStage) cropStage.classList.remove('is-dragging');
      }

      function savePreviewToLocal(bundleToken) {
  if (!bundleToken || !selectedConfig.previewDataUrl) return;

  try {
    localStorage.setItem(
      'ps_preview_' + bundleToken,
      selectedConfig.previewDataUrl
    );
  } catch (e) {
    console.warn('Preview konnte nicht in localStorage gespeichert werden.', e);
  }
}

function getFileExtensionFromType(contentType) {
  var type = String(contentType || '').toLowerCase();

  if (type.indexOf('png') !== -1) return 'png';
  if (type.indexOf('webp') !== -1) return 'webp';
  return 'jpg';
}

function uploadBlobToSignedUrl(uploadUrl, blob, contentType) {
  return fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType
    },
    body: blob
  }).then(function(response) {
    if (!response.ok) {
      throw new Error('Upload nach R2 fehlgeschlagen');
    }
    return response;
  });
}

function updateZoomRangeProgress() {
  if (!zoomRange) return;

  var min = Number(zoomRange.min || 100);
  var max = Number(zoomRange.max || 220);
  var value = Number(zoomRange.value || min);
  var percent = ((value - min) / (max - min)) * 100;

  zoomRange.style.setProperty('--zoom-progress', percent + '%');
}

async function prepareR2Uploads(bundleToken, options) {
  options = options || {};

  /*
   * Für den frühen Original-Upload benutzen wir bewusst einen stabilen
   * bundleToken als Dateinamen. Text kann danach noch geändert werden,
   * ohne dass sich Original-/Preview-Key ändern.
   */
  var headingForName =
    typeof options.heading === 'string'
      ? options.heading
      : (input1 ? input1.value.trim() : '');

  var subheadingForName =
    typeof options.subheading === 'string'
      ? options.subheading
      : (input2 ? input2.value.trim() : '');

  var response = await fetch('https://b2b-deinspar.vercel.app/api/admin/personalised/r2-sign', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
  bundleToken: bundleToken,
  heading: headingForName,
  subheading: subheadingForName,
  originalContentType: (selectedConfig.uploadFile && selectedConfig.uploadFile.type) || 'image/jpeg',
  originalExt: getFileExtensionFromType(selectedConfig.uploadFile && selectedConfig.uploadFile.type),
  previewContentType: 'image/jpeg',
  previewExt: 'jpg'
})
  });

  if (!response.ok) {
    throw new Error('R2-Signierung fehlgeschlagen');
  }

  var data = await response.json();

  if (!data || !data.success || !data.original || !data.preview) {
    throw new Error('Ungültige Antwort von R2-Signierung');
  }

  return data;
}


/*
 * Startet den großen Original-Upload möglichst früh.
 * Fehler werden hier absichtlich nur geloggt, weil der Kunde weiter
 * gestalten können soll. Beim finalen Cart-Klick wird bei Bedarf
 * automatisch erneut versucht.
 */
async function startOriginalUploadEarly() {
  var file = selectedConfig.uploadFile;

  if (!file) {
    return null;
  }

  if (
    originalPreuploadState.file === file &&
    originalPreuploadState.uploaded &&
    originalPreuploadState.signed
  ) {
    return originalPreuploadState.signed;
  }

  if (
    originalPreuploadState.file === file &&
    originalPreuploadState.promise
  ) {
    return originalPreuploadState.promise;
  }

  if (originalPreuploadState.file !== file) {
    resetOriginalPreupload();
  }

  originalPreuploadState.file = file;

  if (!selectedConfig.bundleToken) {
    selectedConfig.bundleToken = createPersonalisedBundleToken();
  }

  var bundleToken = selectedConfig.bundleToken;

  originalPreuploadState.promise = (async function() {
    try {
      /*
       * heading/subheading leer halten:
       * So bleibt der R2-Key stabil, auch wenn der Kunde danach Text ändert.
       */
      var signed = await prepareR2Uploads(bundleToken, {
        heading: '',
        subheading: ''
      });

      await uploadBlobToSignedUrl(
        signed.original.uploadUrl,
        file,
        signed.original.contentType ||
          ((file && file.type) || 'image/jpeg')
      );

      originalPreuploadState.signed = signed;
      originalPreuploadState.uploaded = true;

      selectedConfig.bundleToken =
        signed.bundleToken || bundleToken;

      return signed;
    } catch (error) {
      console.warn(
        'Original konnte nicht vorab hochgeladen werden. Beim Warenkorb-Klick wird erneut versucht.',
        error
      );

      originalPreuploadState.promise = null;
      originalPreuploadState.signed = null;
      originalPreuploadState.uploaded = false;

      return null;
    }
  })();

  return originalPreuploadState.promise;
}


/*
 * Holt eine gültige Signierung mit bereits vorhandenem Original.
 * Falls der frühe Upload fehlgeschlagen ist, wird er hier zuverlässig
 * noch einmal ausgeführt.
 */
async function ensureOriginalUploadedForCart(bundleToken) {
  if (!selectedConfig.uploadFile) {
    throw new Error('Originaldatei fehlt');
  }

  if (!selectedConfig.bundleToken) {
    selectedConfig.bundleToken =
      bundleToken || createPersonalisedBundleToken();
  }

  var signed = await startOriginalUploadEarly();

  if (
    signed &&
    originalPreuploadState.uploaded
  ) {
    return signed;
  }

  /*
   * Ein zweiter, finaler Versuch.
   */
  resetOriginalPreupload();
  originalPreuploadState.file =
    selectedConfig.uploadFile;

  signed = await startOriginalUploadEarly();

  if (
    !signed ||
    !originalPreuploadState.uploaded
  ) {
    throw new Error('Originaldatei konnte nicht hochgeladen werden');
  }

  return signed;
}


/*
 * Die frühe Signierung kann nach längerer Bearbeitungszeit ablaufen.
 * In diesem Fall holen wir nur neue Signed URLs für EXAKT dieselben Keys,
 * indem wir denselben bundleToken und wieder leere Namens-Texte verwenden.
 */
async function uploadPreviewWithRefresh(signed) {
  if (!selectedConfig.previewBlob) {
    throw new Error('Preview-Datei fehlt');
  }

  async function uploadWith(currentSigned) {
    await uploadBlobToSignedUrl(
      currentSigned.preview.uploadUrl,
      selectedConfig.previewBlob,
      currentSigned.preview.contentType || 'image/jpeg'
    );

    return currentSigned;
  }

  try {
    return await uploadWith(signed);
  } catch (firstError) {
    console.warn(
      'Preview-Signierung ist möglicherweise abgelaufen. Neue Signierung wird angefordert.',
      firstError
    );

    var refreshed = await prepareR2Uploads(
      selectedConfig.bundleToken,
      {
        heading: '',
        subheading: ''
      }
    );

    /*
     * Bei gleichem bundleToken + leeren Texten müssen die Keys identisch sein.
     * Falls nicht, stoppen wir lieber, statt Original und Preview zu trennen.
     */
    if (
      !refreshed ||
      !refreshed.original ||
      !signed.original ||
      refreshed.original.key !== signed.original.key
    ) {
      throw new Error('R2-Dateizuordnung konnte nicht erneuert werden');
    }

    originalPreuploadState.signed = refreshed;

    return await uploadWith(refreshed);
  }
}


function parseMetricSizeForRender(sizeLabel) {
  var normalized = String(sizeLabel || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

  var match = normalized.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)\s*cm/);

  if (!match) {
    return {
      widthCm: 0,
      heightCm: 0
    };
  }

  return {
    widthCm: Number(String(match[1]).replace(',', '.')) || 0,
    heightCm: Number(String(match[2]).replace(',', '.')) || 0
  };
}

async function requestServerPreviewRender(signed) {
  if (!signed || !signed.original || !signed.original.key) {
    throw new Error('Original-R2-Key fehlt');
  }

  if (!signed.preview || !signed.preview.key) {
    throw new Error('Preview-R2-Key fehlt');
  }

  if (!selectedConfig.cropData) {
    throw new Error('Crop-Daten fehlen. Bitte den Bildausschnitt erneut bestätigen.');
  }

  var response = await fetch(
    'https://b2b-deinspar.vercel.app/api/admin/personalised/render-preview',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        bundleToken: signed.bundleToken || selectedConfig.bundleToken || '',
        originalKey: signed.original.key,
        previewKey: signed.preview.key,

        heading: input1 ? input1.value.trim() : '',
        subheading: input2 ? input2.value.trim() : '',

        frameStyle: selectedConfig.frameStyle || 'white',
        fontStyle: selectedConfig.fontStyle || 'modern',
        productFrameStyle: selectedConfig.productFrameStyle || 'none',

        crop: selectedConfig.cropData,

        /*
         * Nur das Seitenverhältnis wird benötigt.
         * Der Server erzeugt bewusst nur eine kleine Cart-Preview.
         */
        printWidth: Number(selectedConfig.exportWidth || 0),
        printHeight: Number(selectedConfig.exportHeight || 0)
      })
    }
  );

  var data = null;

  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }

  if (!response.ok) {
    var previewError =
      data && data.error
        ? data.error
        : 'Vorschau konnte nicht erstellt werden';

    throw new Error(previewError);
  }

  if (
    !data ||
    !data.success ||
    !data.preview ||
    !data.preview.publicUrl
  ) {
    throw new Error('Ungültige Antwort vom Preview-Renderer');
  }

  return data;
}


async function requestServerPrintRender(signed) {
  if (!signed || !signed.original || !signed.original.key) {
    throw new Error('Original-R2-Key fehlt');
  }

  if (!selectedConfig.cropData) {
    throw new Error('Crop-Daten fehlen. Bitte den Bildausschnitt erneut bestätigen.');
  }

  var metricSize = parseMetricSizeForRender(selectedConfig.sizeLabel);

  var response = await fetch(
    'https://b2b-deinspar.vercel.app/api/admin/personalised/render-print',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        bundleToken: signed.bundleToken || selectedConfig.bundleToken || '',
        originalKey: signed.original.key,
        previewKey: signed.preview && signed.preview.key ? signed.preview.key : '',
        heading: input1 ? input1.value.trim() : '',
        subheading: input2 ? input2.value.trim() : '',
        frameStyle: selectedConfig.frameStyle || 'white',
        fontStyle: selectedConfig.fontStyle || 'modern',
        crop: selectedConfig.cropData,
        printWidth: Number(selectedConfig.exportWidth || 0),
        printHeight: Number(selectedConfig.exportHeight || 0),
        dpi: 300,
        sizeLabel: selectedConfig.sizeLabel || '',
        sizeKey: selectedConfig.sizeKey || '',
        sizeWidthCm: metricSize.widthCm,
        sizeHeightCm: metricSize.heightCm,
        posterVariantId: selectedConfig.posterVariantId || '',
        frameVariantId: selectedConfig.frameVariantId || '',
        frameLabel: selectedConfig.frameLabel || '',
        productFrameStyle: selectedConfig.productFrameStyle || 'none'
      })
    }
  );

  var data = null;

  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }

  if (!response.ok) {
    var renderError =
      data && data.error
        ? data.error
        : 'Druckdatei konnte nicht erstellt werden';

    throw new Error(renderError);
  }

  if (!data || !data.success || !data.print || !data.print.key) {
    throw new Error('Ungültige Antwort vom Print-Renderer');
  }

  return data;
}

async function uploadPosterAssetsToR2(bundleToken) {
  if (!selectedConfig.uploadFile) {
    throw new Error('Originaldatei fehlt');
  }

  if (!selectedConfig.cropData) {
    throw new Error('Crop-Daten fehlen. Bitte den Bildausschnitt erneut bestätigen.');
  }

  var isMobile =
    isMobilePersonalisedDevice();

  /*
   * Das große Original wurde normalerweise bereits direkt nach der
   * Bildauswahl hochgeladen. Falls es noch läuft, warten wir hier nur
   * auf diesen einen Upload.
   */
  var signed =
    await ensureOriginalUploadedForCart(
      bundleToken
    );

  selectedConfig.bundleToken =
    signed.bundleToken ||
    selectedConfig.bundleToken ||
    bundleToken;

  if (isMobile) {
    /*
     * HANDY:
     * Keine Browser-Screenshot-Engine mehr.
     *
     * Der B2B-Server erstellt aus Original + Crop + Text + Design
     * eine kleine Vorschau und speichert sie direkt unter previewKey.
     * Safari muss dadurch keine große Canvas-/DOM-Arbeit leisten.
     */
    var serverPreview =
      await requestServerPreviewRender(
        signed
      );

    selectedConfig.previewUrl =
      serverPreview.preview.publicUrl || '';

    selectedConfig.previewBlob = null;
  } else {
    /*
     * DESKTOP:
     * Die bestehende html2canvas-Preview funktioniert bei dir sehr gut
     * und bleibt deshalb unverändert.
     */
    if (!selectedConfig.previewBlob) {
      throw new Error('Preview-Datei fehlt');
    }

    signed =
      await uploadPreviewWithRefresh(
        signed
      );

    selectedConfig.previewUrl =
      signed.preview.publicUrl || '';
  }

  /*
   * Die große Print-Datei startet weiterhin nur im Hintergrund.
   * Die API gibt Print-/JSON-Links sofort zurück.
   */
  var rendered =
    await requestServerPrintRender(
      signed
    );

  selectedConfig.printKey =
    rendered.print &&
    rendered.print.key
      ? rendered.print.key
      : '';

  selectedConfig.printUrl =
    rendered.print &&
    rendered.print.publicUrl
      ? rendered.print.publicUrl
      : '';

  selectedConfig.designKey =
    rendered.design &&
    rendered.design.key
      ? rendered.design.key
      : '';

  selectedConfig.designUrl =
    rendered.design &&
    rendered.design.publicUrl
      ? rendered.design.publicUrl
      : '';

  if (
    !selectedConfig.printKey ||
    !selectedConfig.printUrl
  ) {
    throw new Error(
      'Druckdatei-Link konnte nicht vorbereitet werden'
    );
  }

  if (!selectedConfig.previewUrl) {
    throw new Error(
      'Vorschau-Link konnte nicht erstellt werden'
    );
  }

  return rendered;
}

      async function addToCart() {
  if (!selectedConfig.posterVariantId) {
    alert('Bitte wählen Sie zuerst eine gültige Variante aus.');
    return;
  }

  if (!selectedConfig.previewDataUrl) {
    alert('Bitte laden Sie zuerst ein Bild hoch und bestätigen Sie den Zuschnitt.');
    return;
  }

  /*
   * Loading-Zustand SOFORT anzeigen.
   * Zwei requestAnimationFrame geben dem Browser Zeit, Spinner und Text
   * tatsächlich zu zeichnen, bevor eventuell noch Arbeit nötig ist.
   */
  setPrimaryActionLoading(true);
  await waitForUiPaint();

  /*
   * Wenn der frühe Original-Upload bereits läuft/fertig ist,
   * muss exakt derselbe bundleToken weiterverwendet werden.
   */
  var bundleToken =
    selectedConfig.bundleToken ||
    createPersonalisedBundleToken();

  selectedConfig.bundleToken = bundleToken;

  try {
    /*
     * Nur Desktop braucht die Browser-Preview.
     * Auf Handy wird sie gleich serverseitig erstellt – kein html2canvas,
     * kein Safari-Freeze.
     */
    if (!isMobilePersonalisedDevice()) {
      await ensureCartPreviewReady();
    }

    await uploadPosterAssetsToR2(bundleToken);

        var headingValue = input1 ? input1.value.trim() : '';
    var subheadingValue = input2 ? input2.value.trim() : '';

    var visibleLine1 = '';
    var visibleLine2 = '';
    var visibleNoteLabel = modal ? (modal.getAttribute('data-checkout-note-label') || 'Hinweis') : 'Hinweis';
    var visibleNote = modal ? (modal.getAttribute('data-checkout-note') || '') : '';

    if (headingValue && subheadingValue) {
      visibleLine1 = headingValue;
      visibleLine2 = subheadingValue;
    } else if (headingValue) {
      visibleLine1 = headingValue;
    } else if (subheadingValue) {
      visibleLine1 = subheadingValue;
    }

    var items = [
      {
        id: Number(selectedConfig.posterVariantId),
        quantity: 1,
        properties: {
          '_personalisiert': 'Ja',
          '_format': selectedConfig.sizeLabel || '',
          '_rahmen': selectedConfig.frameLabel || '',
          '_ausgabegroesse': selectedConfig.exportWidth + ' x ' + selectedConfig.exportHeight + ' px',
          '_ueberschrift': headingValue,
          '_dachzeile': subheadingValue,
          '_bundle_token': selectedConfig.bundleToken || bundleToken,
          /*
           * Interne Shopify-Admin-Links.
           * Alle Property-Namen beginnen mit "_", deshalb werden sie
           * in unserem Theme nicht für den Kunden ausgegeben.
           *
           * _Druckdatei  = fertige hochauflösende R2-Druckdatei
           * _Vorschau    = kleine R2-Vorschau
           * _Print_Key   = technischer R2-Key der Druckdatei
           * _Design_JSON = gespeicherte Design-/Produktionsdaten
           */
          /*
           * Technische Keys:
           * Diese Namen werden vom Theme / bestehenden Code verwendet.
           * Besonders _preview_url wird im Cart und Mini-Cart benötigt,
           * damit dort das personalisierte Vorschaubild erscheint.
           */
          '_preview_url': selectedConfig.previewUrl || '',
          '_print_url': selectedConfig.printUrl || '',
          '_print_key': selectedConfig.printKey || '',
          '_design_key': selectedConfig.designKey || '',

          /*
           * Zusätzliche, gut lesbare Admin-Felder.
           * Sie bleiben intern, da auch sie mit "_" beginnen.
           */
          '_Druckdatei': selectedConfig.printUrl || '',
          '_Vorschau': selectedConfig.previewUrl || '',
          '_Print_Key': selectedConfig.printKey || '',
          '_Design_JSON': selectedConfig.designUrl || '',
          '1': visibleLine1,
          '2': visibleLine2,
          [visibleNoteLabel]: visibleNote
        }
      }
    ];

    if (selectedConfig.frameVariantId) {
      items.push({
        id: Number(selectedConfig.frameVariantId),
        quantity: 1,
        properties: {
          '_bundle_token': selectedConfig.bundleToken || bundleToken,
          '_parent_poster': String(selectedConfig.posterVariantId)
        }
      });
    }

        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    var response = await fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    window.location.href = shopRoot + 'cart';
  } catch (error) {
    console.error(error);

    var customerErrorMessage =
      error && error.message
        ? String(error.message)
        : 'Beim Vorbereiten der Personalisierung oder beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten.';

    alert(customerErrorMessage);
  } finally {
    /*
     * Bei erfolgreichem cart/add navigieren wir sofort zur Cart-Seite.
     * Falls ein Fehler passiert, wird der Button wieder freigegeben.
     */
    setPrimaryActionLoading(false);
  }
}

      if (!openBtn || !modal) return;

         openBtn.addEventListener('click', function () {
        var ok = syncSelectionFromShopify();
        if (!ok) return;

        if (modal && modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }

        modal.hidden = false;
        document.body.classList.add('ps-modal-open');
        applyFontConfig();
        applyFrameConfig();
        syncSizeButtons();
        syncProductFrameButtons();
        setCropDirty(false);
        switchEditorTab('text');
        switchEditorCanvas('preview');
        showStep(stepUpload, 'upload');
      });

      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          modal.hidden = true;
          document.body.classList.remove('ps-modal-open');
        });
      });

      backBtn.addEventListener('click', function () {
        if (currentStep === 'crop') {
          showStep(stepUpload, 'upload');
        } else if (currentStep === 'customize') {
          if (selectedConfig.uploadFile && cropState.naturalWidth) {
            showStep(stepCustomize, 'crop');
            switchEditorTab('crop');
            switchEditorCanvas('crop');
            setCropDirty(cropDirty);
          } else {
            showStep(stepUpload, 'upload');
          }
        }
      });

      changeImageBtn.addEventListener('click', function () {
        if (imageUpload) {
          imageUpload.value = '';
          imageUpload.click();
        }
      });

      if (uploadPlusBtn && imageUpload) {
        uploadPlusBtn.addEventListener('click', function () {
          imageUpload.value = '';
          imageUpload.click();
        });

        uploadPlusBtn.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            imageUpload.value = '';
            imageUpload.click();
          }
        });
      }

      function handlePersonalisedTextInput() {
        selectedConfig.printKey = '';
        selectedConfig.printUrl = '';
        selectedConfig.designKey = '';
        selectedConfig.designUrl = '';
        updatePreviewText();
        markCartPreviewDirty(true);
      }

      if (input1) input1.addEventListener('input', handlePersonalisedTextInput);
      if (input2) input2.addEventListener('input', handlePersonalisedTextInput);
      updatePreviewText();

      if (imageUpload) {
        imageUpload.addEventListener('change', function (e) {
          var file = e.target.files && e.target.files[0];
          if (!file) return;

          selectedConfig.uploadFile = file;
selectedConfig.previewBlob = null;
selectedConfig.printBlob = null;
selectedConfig.previewUrl = '';
selectedConfig.printKey = '';
selectedConfig.printUrl = '';
selectedConfig.designKey = '';
selectedConfig.designUrl = '';
selectedConfig.cropData = null;
selectedConfig.bundleToken = '';
resetOriginalPreupload();
resetCartPreviewCache();

          if (!/^image\/(png|jpeg|jpg|webp)$/i.test(file.type)) {
            alert('Bitte wählen Sie eine PNG-, JPG- oder WEBP-Datei.');
            imageUpload.value = '';
            return;
          }

          if (uploadFilename) uploadFilename.textContent = file.name;

          /*
           * MOBILE SPEED:
           * Original sofort hochladen – schon bevor der Kunde croppt.
           * Das ist sicher, weil der spätere Crop nur Koordinaten speichert;
           * die Originaldatei selbst ändert sich nicht.
           */
          if (!selectedConfig.bundleToken) {
            selectedConfig.bundleToken = createPersonalisedBundleToken();
          }

          startOriginalUploadEarly();

          var reader = new FileReader();
          reader.onload = function (ev) {
            resetCropState();

    cropImage.onload = function () {
  cropState.naturalWidth = cropImage.naturalWidth;
  cropState.naturalHeight = cropImage.naturalHeight;

  showStep(stepCustomize, 'crop');
  switchEditorTab('crop');
  switchEditorCanvas('crop');

  requestAnimationFrame(function () {
    fitImageToStage();
    updateQualityIndicator();
    setCropDirty(true);
  });
};

            cropImage.src = ev.target.result;
          };
          reader.readAsDataURL(file);
        });
      }

      if (rotateBtn) {
        rotateBtn.addEventListener('click', function () {
          cropState.rotation = (cropState.rotation + 90) % 360;
          fitImageToStage();
          markCropAsChanged();
        });
      }

      if (zoomRange) {
  zoomRange.addEventListener('input', function () {
    var value = Number(zoomRange.value || 100);
    cropState.zoom = Math.max(1, value / 100);
    updateZoomRangeProgress();
    applyCropTransform();
    markCropAsChanged();
  });
}

     if (cropStage) {
  cropStage.addEventListener('mousedown', function (e) {
    e.preventDefault();
    pointerDown(e.clientX, e.clientY);
  });

  cropStage.addEventListener('wheel', function (e) {
    e.preventDefault();

    if (!zoomRange) return;

    var currentValue = Number(zoomRange.value || 100);
    var delta = e.deltaY < 0 ? 6 : -6;
    var nextValue = Math.max(100, Math.min(220, currentValue + delta));

    zoomRange.value = String(nextValue);
    cropState.zoom = Math.max(1, nextValue / 100);
    updateZoomRangeProgress();
    applyCropTransform();
    markCropAsChanged();
  }, { passive: false });

  window.addEventListener('mousemove', function (e) {
    pointerMove(e.clientX, e.clientY);
  });

  window.addEventListener('mouseup', pointerUp);

  cropStage.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches[0]) return;
    pointerDown(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true });

  window.addEventListener('touchmove', function (e) {
    if (!cropState.dragging || !e.touches || !e.touches[0]) return;
    pointerMove(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true });

  window.addEventListener('touchend', pointerUp);

  window.addEventListener('resize', function () {
    if ((currentStep === 'crop' || currentStep === 'customize') && cropState.naturalWidth) {
      fitImageToStage();
    }
  });
}

      if (cropConfirmBtn) {
        cropConfirmBtn.addEventListener('click', renderCropToPreview);
      }

      if (newUploadBtn) {
        newUploadBtn.addEventListener('click', function () {
          if (imageUpload) {
            imageUpload.value = '';
            imageUpload.click();
          }
        });
      }

      if (primaryActionBtn) {
        primaryActionBtn.addEventListener('click', function () {
          if (primaryActionBtn.disabled) return;

          var action = primaryActionBtn.getAttribute('data-action') || 'next';

          if (action === 'add-to-cart') {
            addToCart();
            return;
          }

          goToNextEditorStep();
        });
      }

      ensurePrimaryActionLoadingUi();
      updatePrimaryActionState(currentEditorTab);

syncCustomSizePicker();
refreshCustomFramePricesDelayed(250);
});